import { SOCIAL_PLATFORM_ICON_PATHS, type SocialPlatformKey } from "@salon/types";

interface SocialPlatformIconProps {
  platform: SocialPlatformKey;
  className?: string;
}

export function SocialPlatformIcon({ platform, className }: SocialPlatformIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {SOCIAL_PLATFORM_ICON_PATHS[platform].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
